var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tr",
    { class: { "show-all": _vm.showMoreDetails == true } },
    [
      _c(
        "td",
        {
          class: { "d-block hide-desktop": _vm.index > 0 },
          attrs: { "data-col": "title" }
        },
        [
          _c("product-title-component", {
            attrs: {
              productName: _vm.product.ProductName,
              brandName: _vm.plantDetails.BrandName,
              productId: _vm.product.ProductID,
              plantId: _vm.plantDetails.PlantClassID,
              isOnSale: _vm.isOnSale
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm._l(_vm.columns, function(column, i) {
        return _c("td", { key: i, attrs: { "data-col": column } }, [
          _vm._v("\n        " + _vm._s(_vm.columnMap[column]) + "\n    ")
        ])
      }),
      _vm._v(" "),
      _c(
        "td",
        { attrs: { "data-col": "quantity" } },
        [
          _c("product-quantity-component", {
            attrs: {
              productId: _vm.product.ProductID,
              plantId: _vm.plantDetails.PlantClassID,
              inventory: _vm.product.availability.AvailQty
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "td",
        {
          attrs: { "data-col": "showMore" },
          on: {
            click: function($event) {
              _vm.showMoreDetails = !_vm.showMoreDetails
            }
          }
        },
        [
          _vm.showMoreDetails
            ? _c("span", [
                _vm._v("View Less Details "),
                _c("span", { staticClass: "fa ml-1 fa-minus" })
              ])
            : _vm._e(),
          !_vm.showMoreDetails
            ? _c("span", [
                _vm._v("View More Details "),
                _c("span", { staticClass: "fa ml-1 fa-plus" })
              ])
            : _vm._e()
        ]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }